import BaseModal from '@/components/Modals/BaseModal';
import React from 'react';
const DeletePaymentModal = ({
  handleCloseModal,
  handleDeletePaymentMethod,
  id,
}) => {
  return (
    <BaseModal
      icon='/icons/warning-full.svg'
      title='Delete Payment Method'
      text='If you delete this payment method, it will no longer be available for the future transactions. This action cannot be undone.'
      cancelButton
      primaryButtonText='Delete'
      handlePrimaryButton={() => handleDeletePaymentMethod(id)}
      handleCancel={handleCloseModal}
    />
  );
};
export default DeletePaymentModal;
